module.exports = __webpack_public_path__ + "static/media/icon-prescription.8cf332b7.svg";